module.exports = __webpack_public_path__ + "static/rpo-policy-new-9b2c8685997bee5c2feade3364d81306.png";